<template>
  <div id="pageRoot">
    <p class="textBase" style="position: absolute; width: 480px; font-size: 26px; top: 50px; left: 570px; text-align: left;">
		EL GRILLO PERDIÓ EL VIOLÍN<br>EN LA ARENA DEL ZAUZAL;<br>LLORA QUE LLORA EN LA ORILLA<br>CON LAGRIMAS DE CRISTAL.<br><br>SE LO BUSCA AL GUITARRERO<br>SE LO BUSCA AL CARDENAL,<br>SE LO BUSCA LA RANITA<br>SIN PODERLO NUNCA HALLAR.<br><br>EL TERITO REAL<br>ESCRIBIÓ EN LA ARENA,<br>PARA QUE EL GRILLITO<br>NO MUERA DE PENA.
    </p>

    <img src="/pages/img/sordovio/assets_p3/burbuja.svg" style="position: absolute; width: 390px; top: 90px; left: 90px; z-index: 3"  class="hover-animation-a"/>

    <img src="/pages/img/sordovio/assets_p3/nube.svg" style="position: absolute; width: 300px; top: 190px; left: 200px; z-index: 3"  class="slideItemB"/>
    <img src="/pages/img/sordovio/assets_p3/piso.svg" style="position: absolute; width: 950px; top: 340px; left: 20px; z-index: 3"/>
    <img src="/pages/img/sordovio/assets_p3/grillo.svg" style="position: absolute; width: 150px; top: 370px; left: 360px; z-index: 1"  class="bouncingItemB"/>

  </div>
</template>
<style scoped>
#bg{
    position: absolute;
    left: 22px;
    top: 58px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "vio/Video 3.mp4",
        "vio/Video 4.mp4",
        "vio/Video 5.mp4",
        ]
    }
  }
}
</script>